import React from "react";

import {
  FooterBar,
  CopyRightItem,
  CopyRightContainer,
} from "./styled/Footer.styled";

export default function Footer() {
  return (
    <FooterBar >
      <CopyRightContainer >
        <CopyRightItem>
          © Copyright 2022 | EDOTCO Group | <b>Disclaimer</b> : If you find any issue with the NaPA system , please report here in <a target="_blank" rel="noopener noreferrer" href="https://esolver.edotcogroup.com/home">esolver</a> with a screenshot of the issue.
        </CopyRightItem>
      </CopyRightContainer>
    </FooterBar>
  );
}
